"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assignToDisplayFormats = void 0;
exports.assignToDisplayFormats = ["image_only", "image_name"];
